<div class="floating-dialogs-host">
  @for (dialog of service.dialogs$ | async; track dialog.id) {
    <app-floating-dialog-container [dialog]="dialog" />
  }
</div>
